import NotFoundIcon from '@/assets/icons/not-found.svg?react'
import { Button } from '@/components'

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <div className="flex flex-col gap-y-1 items-center mb-4">
        <NotFoundIcon className="w-[120px] h-[120px] text-tertiary" />
        <h1 className="t-bold">Page Not Found</h1>
        <p className="t-sm text-secondary">Oops! The page you’re looking for doesn’t exist.</p>
      </div>
      <Button
        type="secondary"
        onClick={() => {
          window.location.href = '/'
        }}
      >
        Go Homepage
      </Button>
    </div>
  )
}
